import store from '../../store/store';
import setClauseValue from '../setClauseValue';
import { action } from 'satcheljs/lib/legacy';

/**
 * Removes the phrase pill from the input box of the 'includes' type of clauses
 * @param clauseId the id of the clause to remove the phrase from
 * @param phraseToRemove the phrase to remove from the clause
 */
export default action('removePhraseFromClause')(function removePhraseFromClause(
    clauseId: string,
    phraseToRemove: string
) {
    let existingPhrases = store.inboxRulesEditState.clauseMap.get(clauseId).clauseValue as string[];
    let indexToRemove = existingPhrases.indexOf(phraseToRemove);

    if (indexToRemove == -1) {
        throw new Error('Phrase not found in existing phrases');
    }

    existingPhrases.splice(indexToRemove, 1);
    setClauseValue(existingPhrases, clauseId);
});
